export class PremiumExpendableCouponHistory {
  constructor(
    public id: string,
    public name: string,
    public useDt: Date,
    public useNum: number
  ) {}
}
